import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-white border-t border-zinc-200 py-12 px-6 md:px-16 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 mb-4">
              {/* Shield icon */}
              <svg 
                className="h-8 w-auto" 
                viewBox="0 0 40 48" 
                fill="none" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <linearGradient id="footerShieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#1DA1F2" />
                    <stop offset="100%" stopColor="#2563EB" />
                  </linearGradient>
                </defs>
                <path 
                  d="M4 10C4 10 20 4 20 4C20 4 36 10 36 10V28C36 36 20 44 20 44C20 44 4 36 4 36V10Z" 
                  fill="url(#footerShieldGradient)"
                />
                <path 
                  d="M12 24L18 30L28 18" 
                  stroke="#1e293b" 
                  strokeWidth="3.5" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                  fill="none"
                />
                <circle cx="32" cy="12" r="7" fill="#1e293b" />
                <path d="M32 8V16M28 12H36" stroke="white" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span className="font-outfit text-xl font-semibold tracking-tight">
                <span className="text-zinc-900">Proof</span>
                <span className="text-[#1DA1F2]">ix</span>
              </span>
            </Link>
            <p className="text-zinc-600 text-sm leading-relaxed max-w-sm">
              Proofix geeft zzp'ers snel duidelijkheid over de wet DBA. 
              Simpel, zonder moeilijke taal.
            </p>
          </div>

          {/* Products */}
          <div>
            <h4 className="font-outfit font-medium text-zinc-900 mb-4">Producten</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/dba-check" 
                  className="text-sm text-zinc-600 hover:text-blue-600 transition-colors"
                  data-testid="footer-dba-check"
                >
                  DBA Check
                </Link>
              </li>
              <li>
                <span className="text-sm text-zinc-400">Contract Check (binnenkort)</span>
              </li>
              <li>
                <span className="text-sm text-zinc-400">Team Scan (binnenkort)</span>
              </li>
            </ul>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-outfit font-medium text-zinc-900 mb-4">Links</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/partner" 
                  className="text-sm text-zinc-600 hover:text-blue-600 transition-colors"
                  data-testid="footer-partner"
                >
                  Partner worden
                </Link>
              </li>
              <li>
                <Link 
                  to="/partner-dashboard" 
                  className="text-sm text-zinc-600 hover:text-blue-600 transition-colors"
                  data-testid="footer-partner-portal"
                >
                  Partner portaal
                </Link>
              </li>
              <li>
                <Link 
                  to="/admin" 
                  className="text-sm text-zinc-600 hover:text-blue-600 transition-colors"
                  data-testid="footer-admin"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-zinc-200 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-zinc-500">
            © {new Date().getFullYear()} Proofix. Alle rechten voorbehouden.
          </p>
          <p className="text-xs text-zinc-400">
            Deze tool geeft indicatief advies en vervangt geen juridisch of fiscaal advies.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
